import {
    ZOBJECT_CREATED,
    INLET_TOGGLED,
    ZOBJECT_DELETED,
    ZMESSAGE_DELETED,
    ZMESSAGE_CREATED,
    INLET_CREATED,
    OUTLET_CREATED,
    INLET_DELETED,
    OUTLET_DELETED,
    CONNECTION_CREATED,
    CONNECTION_DELETED,
    ZOBJECT_UPDATED,
    ZMESSAGE_UPDATED,
} from './operations.js';

import {zmessageDeleted, zobjectDeleted} from './delete.js';
import {
    inletCreated,
    outletCreated,
    zobjectCreated,
    zmessageCreated} from './create.js';

import {
    connectionCreated,
    connectionDeleted,
} from './connection.js';
import {
    inletToggled,
    zobjectUpdated,
    zmessageUpdated} from './update.js';

export const propagate = (subpatch, action) => {
    let fn = undefined;
    switch (action.type) {
    case ZOBJECT_CREATED:
        fn = zobjectCreated;
        break;
    case ZMESSAGE_CREATED:
        fn = zmessageCreated;
        break;
    case ZOBJECT_UPDATED:
        fn = zobjectUpdated;
        break;
    case ZMESSAGE_UPDATED:
        fn = zmessageUpdated;
        break;
    case INLET_CREATED:
        fn = inletCreated;
        break;
    case OUTLET_CREATED:
        fn = outletCreated;
        break;
    case CONNECTION_CREATED:
        fn = connectionCreated;
        break;
    case CONNECTION_DELETED:
        fn = connectionDeleted;
        break;
    case ZOBJECT_DELETED:
        fn = zobjectDeleted;
        break;
    case ZMESSAGE_DELETED:
        fn = zmessageDeleted;
        break;
    case INLET_TOGGLED:
        fn = inletToggled;
        break;
    }

    if (fn) {
        fn(subpatch, action);
    }
};
